var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"deleteModal",attrs:{"centered":"","title":_vm.title && _vm.title,"ok-title":_vm.$t(_vm.tKey + 'deleteOk'),"cancel-title":_vm.$t(_vm.tKey + 'deleteCancel'),"ok-variant":"danger"},on:{"ok":function($event){return _vm.$emit('delete')}}},[_c('p',{staticClass:"lead",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.tKey + 'deleteWarning'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }